<template>
  <div
    :class="[
      'text-body text-decoration-none',
      {
        'list-group-item-format': format === 'list-group-item',
        'col-12': format === 'list-group-item' && grid,
        'card-format': format === 'card',
        'col-12 col-md-6 col-xl-4': format === 'card' && grid
      }
    ]"
  >

    <!-- .list-group-item -->
    <span
      v-if="format === 'list-group-item'"
      class="card mb-2"
    >
      <span class="card-body p-0 text-body text-decoration-none position-relative">
        <span class="media align-items-center">
          <span class="media-left">
            <span class="listing-image-thumb-square mr-3" :style="`background-image:url(${image})`"></span>
          </span>
          <span class="media-body position-relative">
            <a
              :href="link ? urls.listings.show(listing.id) : 'javascript:;'"
              class="d-block font-weight-bold text-truncate p-0 col-11 col-lg-12"
            >
              {{ listing.street_address }}
            </a>
            <span class="d-block small text-truncate p-0 col-11 col-lg-12">
              {{ listing.city }}, {{ listing.state }} {{ listing.zip }}
            </span>
            <span class="d-block small text-uppercase">
              {{ listing.mls_connection }} #{{ listing.mls_id }}
            </span>
          </span>
          <span class="media-right d-none d-lg-flex align-items-center">
            <span
              :class="listingStatusBadgeClass"
            >
              {{ listing.list_status }}
            </span>
            <i
              v-if="link"
              class="fa fa-chevron-right mx-3"
            ></i>
          </span>
        </span>
      </span>
      <span class="badge badge-dark small badge-mls-connection border-0 text-uppercase">
        {{ listing.mls_connection }}
      </span>
      <span
        :class="`position-absolute small d-inline-block d-lg-none ${listingStatusBadgeClass}`"
      >
        {{ listing.list_status }}
      </span>
    </span>
    <!-- /.list-group-item -->

    <!-- .card -->
    <span
      v-if="format === 'card'"
      class="card mb-3 position-relative"
    >
      <img
        :src="image"
        class="card-img-top"
        :alt="listing.street_address"
      >
      <span
        v-if="variant === 'admin'"
        class="card-body media align-items-center position-relative"
      >
        <div class="media-body">
          <a
            class="card-title font-weight-bold d-block mb-0 h5"
            :href="link ? urls.listings.show(listing.id) : 'javascript:;'"
          >
            {{ listing.street_address }}
          </a>
          <span class="card-text small">
            {{ listing.city }}, {{ listing.state }} {{ listing.zip }}
          </span>
          <span class="d-block small text-uppercase">
            {{ listing.mls_connection }} #{{ listing.mls_id }}
          </span>
        </div>
        <span :class="listingStatusBadgeClass">
          {{ listing.list_status }}
        </span>
      </span>
      <span
        v-if="variant === 'display'"
        class="card-body position-relative"
      >
        <div class="">
          <span class="card-title font-weight-bold d-block mb-2 h4">
            {{ price }}
          </span>
          <span class="card-text d-block">
            <span>
              {{ listing.beds }} {{ listing.beds === 1 ? 'Bed' : 'Beds' }}
            </span>
            <span class="ml-2">
              {{ listing.baths }} {{ listing.beds === 1 ? 'Bath' : 'Baths' }}
            </span>
            <span
              v-if="listing.area_living > 0"
              class="ml-2"
            >
              {{ livingArea }} Sq. Ft.
            </span>
          </span>
          <span class="card-text small">
            {{ listing.street_address }} {{ listing.city }}, {{ listing.state }} {{ listing.zip }}
          </span>
          <span class="d-block small text-uppercase">
            {{ listing.mls_connection }} #{{ listing.mls_id }}
          </span>
        </div>
        <div class="mt-3">
          <subscribe-button
            to="App\Listing"
            :id="listing.id"
          ></subscribe-button>
        </div>
        <slot name="footer"></slot>
        <span :class="listingStatusBadgeClass">
          {{ listing.list_status }}
        </span>
      </span>
      <span class="badge badge-dark small badge-mls-connection border-0 text-uppercase">
        {{ listing.mls_connection }}
      </span>
    </span>
    <!-- /.card -->

  </div>
</template>

<style lang="scss" scoped>
.listing-image-thumb-square {
  display: block;
  width: 75px;
  height: 75px;
  margin-right: 1rem;
  background-position: center;
  background-size: cover;
  background-color: #eee;
}

.list-group-item-format {
  .badge-mls-connection {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}

.card-format {
  .badge-mls-connection {
    position: absolute;
    top: 0;
    left: 0;
  }
  .badge-status {
    position: absolute;
    top: -28px;
    right: 10px;
  }
}

.badge-status.position-absolute {
  bottom: 0;
  right: 0;
  border-radius: 0;
}
</style>

<script>
import numeral from 'numeral'
import urls from '@/api/urls'
import SubscribeButton from '@/components/reactions/SubscribeButton'

export default {
  components: {
    SubscribeButton
  },
  props: {
    listing: {
      type: Object,
      required: true
    },
    format: {
      type: String,
      default: 'list-group-item'
    },
    variant: {
      type: String,
      default: 'admin' // or "display"
    },
    link: {
      type: Boolean,
      default: true
    },
    grid: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      urls
    }
  },
  computed: {
    price () {
      return numeral(this.listing.list_price).format('$0,0')
    },
    livingArea () {
      return numeral(this.listing.area_living).format('0,0')
    },
    listingStatusBadgeClass () {
      if (this.isActive()) {
        return 'badge badge-success badge-status'
      } else {
        return 'badge badge-light-gray badge-status'
      }
    },
    image () {
      return this.listing.image || 'https://c21redwood-static.s3.us-east-1.amazonaws.com/images/placeholders/placeholder-residential.png'
    }
  },
  methods: {
    isActive () {
      return this.listing.active;
    }
  }
}
</script>